import React from 'react';

import { Card, Divider } from 'components';
import CreateUser from '../Register/CreateUser';

const UserDefinitionsView = () => {
  return (
    <Card className="flex flex-col lg:p-4">
      <Divider text="Kullanıcı Ekleyin veya Düzenleyin" />
      <CreateUser />
    </Card>
  );
};

export default UserDefinitionsView;
